// src/utils/auth.js

const AUTH_KEY = "livequiz_auth";

export function setAuthData(data) {
  // data: { token, user }
  localStorage.setItem(AUTH_KEY, JSON.stringify(data));
}

export function getAuthData() {
  try {
    const raw = localStorage.getItem(AUTH_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function getCurrentUser() {
  const auth = getAuthData();
  return auth?.user || null;
}

export function getToken() {
  const auth = getAuthData();
  return auth?.token || null;
}

export function clearAuth() {
  localStorage.removeItem(AUTH_KEY);
}
